import { defineStore } from 'pinia'
import { ref } from '@nuxtjs/composition-api'

export const useDiffCheckModel = defineStore('diffCheck', () => {
  const status = ref<boolean>(false)
  const isDisabled = ref<boolean>(false)

  const updateStatus = (value: boolean) => {
    status.value = value
  }
  return {
    status,
    isDisabled,
    updateStatus
  }
})
